module.exports = __webpack_public_path__ + "static/media/Page12.66dccbf2.png";